import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MobileTableCardComponent } from './mobile-table-card.component';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { LodgedComplaintsCardComponent } from './components/lodged-complaints-card/lodged-complaints-card.component';
import { TableCardDisplayComponent } from './components/table-card-display/table-card-display.component';
import { ScannedAssetsCardComponent } from './components/scanned-assets-card/scanned-assets-card.component';
import { InventoryDetailsCardComponent } from './components/inventory-details-card/inventory-details-card.component';
import { SharedPipesModule } from 'src/app/shared/pipe/shared-pipes.module';

const components = [
  MobileTableCardComponent,
  LodgedComplaintsCardComponent,
  TableCardDisplayComponent,
  ScannedAssetsCardComponent,
  InventoryDetailsCardComponent,
];

@NgModule({
  declarations: [...components],
  imports: [CommonModule, MaterialModule, SharedPipesModule],
  exports: [...components],
})
export class MobileTableCardModule {}
